import React from 'react';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { CreditLineFormValues } from '../model';

interface Props {
  isLoading: boolean;
}

export const CreditLineNotes = ({ isLoading }: Props) => {
  const { control } = useFormContext<CreditLineFormValues>();

  return (
    <Box className="notesSection">
      <InputField
        label="Notes"
        name="allNotes"
        control={control}
        inputProps={{ minRows: 4, maxRows: 6, disabled: true, multiline: true, variant: 'outlined' }}
      />

      <Box className="customNote">
        <InputField
          name="notes"
          label="Note"
          control={control}
          inputProps={{
            disabled: isLoading,
            placeholder: 'Enter your note...',
          }}
        />
      </Box>
    </Box>
  );
};
